import { render, staticRenderFns } from "./UserWish.vue?vue&type=template&id=4e6c04dd&scoped=true"
import script from "./UserWish.vue?vue&type=script&lang=js"
export * from "./UserWish.vue?vue&type=script&lang=js"
import style0 from "./UserWish.vue?vue&type=style&index=0&id=4e6c04dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c04dd",
  null
  
)

export default component.exports